import { render, staticRenderFns } from "./AuthWrapper.vue?vue&type=template&id=21c3eba6&lang=pug&"
import script from "./AuthWrapper.vue?vue&type=script&lang=js&"
export * from "./AuthWrapper.vue?vue&type=script&lang=js&"
import style0 from "./AuthWrapper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports